import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, c as esm, o as objectWithoutPropertiesLoose, e as esm$1} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {c as core} from "../../common/index-0a000c27.js";
import {S as SwitchBase_1} from "../../common/SwitchBase-711b34d4.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {c as createSvgIcon_1} from "../../common/createSvgIcon-ee034812.js";
import _jsxRuntime from "react/jsx-runtime";
import {c as capitalize} from "../../common/capitalize-0607751a.js";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/clsx.m-5dc7436b.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/useControlled-c12dd7f0.js";
import "../../common/useFormControl-9e2a3560.js";
import "../../common/index-ef2a811c.js";
import "../../common/useForkRef-b591be37.js";
import "../../common/useEventCallback-f6be53c8.js";
import "../../common/useIsFocusVisible-28d126d4.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
var RadioButtonUnchecked = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), "RadioButtonUnchecked");
  exports.default = _default;
});
var RadioButtonChecked = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  var _createSvgIcon = interopRequireDefault(createSvgIcon_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  var _default = (0, _createSvgIcon.default)(/* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
  }), "RadioButtonChecked");
  exports.default = _default;
});
var RadioButtonIcon_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _RadioButtonUnchecked = interopRequireDefault(RadioButtonUnchecked);
  var _RadioButtonChecked = interopRequireDefault(RadioButtonChecked);
  var _styled = interopRequireDefault(styled_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const RadioButtonIconRoot = (0, _styled.default)("span")({
    position: "relative",
    display: "flex"
  });
  const RadioButtonIconBackground = (0, _styled.default)(_RadioButtonUnchecked.default, {
    skipSx: true
  })({
    transform: "scale(1)"
  });
  const RadioButtonIconDot = (0, _styled.default)(_RadioButtonChecked.default, {
    skipSx: true
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    left: 0,
    position: "absolute",
    transform: "scale(0)",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.shortest
    })
  }, ownerState.checked && {
    transform: "scale(1)",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shortest
    })
  }));
  function RadioButtonIcon(props) {
    const {
      checked = false,
      classes = {},
      fontSize
    } = props;
    const ownerState = (0, _extends2.default)({}, props, {
      checked
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(RadioButtonIconRoot, {
      className: classes.root,
      ownerState,
      children: [/* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioButtonIconBackground, {
        fontSize,
        className: classes.background,
        ownerState
      }), /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioButtonIconDot, {
        fontSize,
        className: classes.dot,
        ownerState
      })]
    });
  }
  var _default = RadioButtonIcon;
  exports.default = _default;
});
var createChainedFunction = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = esm.unstable_createChainedFunction;
  exports.default = _default;
});
var RadioGroupContext_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var React$1 = _interopRequireWildcard(React);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const RadioGroupContext = /* @__PURE__ */ React$1.createContext();
  var _default = RadioGroupContext;
  exports.default = _default;
});
var useRadioGroup_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = useRadioGroup;
  var React$1 = _interopRequireWildcard(React);
  var _RadioGroupContext = interopRequireDefault(RadioGroupContext_1);
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function useRadioGroup() {
    return React$1.useContext(_RadioGroupContext.default);
  }
});
var radioClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getRadioUtilityClass = getRadioUtilityClass;
  function getRadioUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiRadio", slot);
  }
  const radioClasses = (0, core.generateUtilityClasses)("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary"]);
  var _default = radioClasses;
  exports.default = _default;
});
var Radio_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _SwitchBase = interopRequireDefault(SwitchBase_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _RadioButtonIcon = interopRequireDefault(RadioButtonIcon_1);
  var _capitalize = interopRequireDefault(capitalize);
  var _createChainedFunction = interopRequireDefault(createChainedFunction);
  var _useRadioGroup = interopRequireDefault(useRadioGroup_1);
  var _radioClasses = _interopRequireWildcard(radioClasses_1);
  var _styled = _interopRequireWildcard(styled_1);
  const _excluded = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      color
    } = ownerState;
    const slots = {
      root: ["root", `color${(0, _capitalize.default)(color)}`]
    };
    return (0, _extends2.default)({}, classes, (0, core.unstable_composeClasses)(slots, _radioClasses.getRadioUtilityClass, classes));
  };
  const RadioRoot = (0, _styled.default)(_SwitchBase.default, {
    shouldForwardProp: (prop) => (0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`color${(0, _capitalize.default)(ownerState.color)}`]];
    }
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    color: theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: (0, esm$1.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }, ownerState.color !== "default" && {
    [`&.${_radioClasses.default.checked}`]: {
      color: theme.palette[ownerState.color].main
    }
  }, {
    [`&.${_radioClasses.default.disabled}`]: {
      color: theme.palette.action.disabled
    }
  }));
  function areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) {
      return a === b;
    }
    return String(a) === String(b);
  }
  const defaultCheckedIcon = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_RadioButtonIcon.default, {
    checked: true
  });
  const defaultIcon = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_RadioButtonIcon.default, {});
  const Radio2 = /* @__PURE__ */ React$1.forwardRef(function Radio3(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiRadio"
    });
    const {
      checked: checkedProp,
      checkedIcon = defaultCheckedIcon,
      color = "primary",
      icon = defaultIcon,
      name: nameProp,
      onChange: onChangeProp,
      size = "medium"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      color,
      size
    });
    const classes = useUtilityClasses(ownerState);
    const radioGroup = (0, _useRadioGroup.default)();
    let checked = checkedProp;
    const onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
      if (typeof checked === "undefined") {
        checked = areEqualValues(radioGroup.value, props.value);
      }
      if (typeof name === "undefined") {
        name = radioGroup.name;
      }
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioRoot, (0, _extends2.default)({
      type: "radio",
      icon: /* @__PURE__ */ React$1.cloneElement(icon, {
        fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
      }),
      checkedIcon: /* @__PURE__ */ React$1.cloneElement(checkedIcon, {
        fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
      }),
      ownerState,
      classes,
      name,
      checked,
      onChange,
      ref
    }, other));
  });
  var _default = Radio2;
  exports.default = _default;
});
var Radio = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    radioClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Radio.default;
    }
  });
  Object.defineProperty(exports, "radioClasses", {
    enumerable: true,
    get: function() {
      return _radioClasses.default;
    }
  });
  var _Radio = interopRequireDefault(Radio_1);
  var _radioClasses = _interopRequireWildcard(radioClasses_1);
  Object.keys(_radioClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _radioClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _radioClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Radio);
export default __pika_web_default_export_for_treeshaking__;
